export const AutomationsTab = {
  systemTemplates: 'system-templates',
  customTemplates: 'custom-templates',
  triggers: 'triggers',
  customFields: 'custom-fields',
  reviews: 'reviews',
  preArrivalForm: 'pre-arrival-form',
  scheduledMessages: 'scheduled-messages',
  messageLog: 'message-log',
  calendarTools: 'calendar-tools',
};

export type AutomationsTabType =
  (typeof AutomationsTab)[keyof typeof AutomationsTab];

export const automationsSidePanelId = 'automations-side-panel';

export const DEFAULT_AUTOMATIONS_PAGE_SIZE = 13;
